import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Standard edit-screen action footer: Save (primary), optional extra actions
 * (projected via [extra-actions]), Cancel link, and an optional Delete pinned
 * to the right. Owns the ONE calibrated footer geometry so screens stop
 * forking it privately and drifting (the tables screen's Delete misalignment
 * came from exactly such a fork). The geometry is a verbatim port of the
 * approved store-offer footer: fixed above the Reload band with the
 * chrome-calibrated widths (290px expanded / 82px sidebar-minimized ≥lg /
 * 50px below 1200), full-width sticky below sm.
 * Pages hosting it reserve scroll clearance exactly like the offer editor:
 *   :host { @include admin-page-sticky-footer-content-bottom; }
 */
@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss'],
})
export class FormFooterComponent {
  @Input() saveLabel = 'admin.global.save';
  @Input() saveDisabled = false;
  @Input() saveTestId = 'form-footer-save-button';
  @Input() cancelLabel = 'admin.global.cancel';
  /** A few editors (catalog station/printer) ship without a Cancel link. */
  @Input() showCancel = true;
  @Input() showDelete = false;
  @Input() deleteLabel = 'admin.global.delete';
  @Input() deleteTestId = 'form-footer-delete-button';
  @Input() deleteDisabled = false;

  @Output() save = new EventEmitter<void>();
  @Output() cancelClick = new EventEmitter<void>();
  /** Named *Click: `cancel` and `delete` are native DOM event names —
   @angular-eslint/no-output-native forbids them as outputs. */
  @Output() deleteClick = new EventEmitter<void>();
}
